import { useContext, useEffect, useState } from 'react';
import { getOperatingAccountBalance, getTrustAccountBalance, listTrustAccount } from 'services/billingServices';
import { UserDetailsContext } from 'context/userDetailsContext';
import { handlePageNumberInPagination } from 'common/pagination';
import { convertToTimezoneFormat } from 'utils/utility_functions/timezone';
import moment from 'moment';
import { setTimezoneWithoutAlteringTime } from 'utils/utility_functions/timezone';

export function useTrustAccountList({ _pageSize = 10, _filter = {} }) {
  const userContext = useContext(UserDetailsContext);
  const [data, setData] = useState([]);
  const [isForward, setIsForward] = useState(true);
  const [pageSize, setpageSize] = useState(userContext?.firmDetails?.pagination_preference?.case?.trust_list || _pageSize);
  const [trustBalance, setTrustBalance] = useState(0);
  const [operatingBalance, setOperatingBalance] = useState(0);
  const [openingBalance, setOpeningBalance] = useState(0);
  const [reconciledBalance, setReconciledBalance] = useState(0);
  const [totalTrustBalance, setTotalTrustBalance] = useState(0);
  const [designatedAsTempTrustFunds, setDesignatedAsTempTrustFunds] = useState(0);
  const [trustFundAvailableToBillAgainst, setTrustFundAvailableToBillAgainst] = useState(0);
  const [availableBalance, setAvailableBalance] = useState(0);

  const next_Token = data?.next_token;
  const transition_Token = data?.transition_token;
  const trustLogs = data?.['transaction_detail'] || [];

  const hasNext = next_Token === null && isForward;
  const hasPrevious = transition_Token === null || (transition_Token && next_Token === null && !isForward);

  useEffect(() => {
    setpageSize(userContext?.firmDetails?.pagination_preference?.case?.trust_list || _pageSize);
  }, [userContext?.firmDetails]); // eslint-disable-line

  const fetchNext = () => {
    setIsForward(true);
    loadTrustLogs({
      limit: pageSize,
      pagination_token: !isForward ? transition_Token : next_Token,
      pagination_direction: 'forward',
    });
  };

  const fetchprev = () => {
    setIsForward(false);
    loadTrustLogs({
      limit: pageSize,
      pagination_token: isForward ? transition_Token : next_Token,
      pagination_direction: 'reverse',
    });
  };

  const onPageChange = (e) => {
    handlePageNumberInPagination(userContext, 'case', '', 'trust_list', e?.value);
    setpageSize(e?.value);
    loadTrustLogs({
      limit: e?.value,
      pagination_token: '',
      pagination_direction: 'forward',
    });
  };

  const pickExtractedDate = (dateArray) => {
    return {
      transaction_date_lower: dateArray?.[0]
        ? setTimezoneWithoutAlteringTime(moment(dateArray[0]).startOf('day'), userContext?.userDetails.timezone)
        : '',
      transaction_date_upper: dateArray?.[0]
        ? setTimezoneWithoutAlteringTime(moment(dateArray[1] ? dateArray[1] : dateArray[0]).endOf('day'), userContext?.userDetails.timezone)
        : '',
    };
  };

  const loadTrustLogs = ({ limit = pageSize, pagination_token, pagination_direction, filter = _filter }) => {
    let filterParam = { ...filter };
    if (filterParam?.dateFilter?.[0]) {
      filterParam = {
        ...filterParam,
        ...pickExtractedDate(filterParam?.dateFilter),
      };
      delete filterParam?.dateFilter;
    }
    listTrustAccount({ limit, pagination_token, pagination_direction, filter: filterParam })
      .then((response) => setData(response?.data))
      .catch((error) => console.log(error));
  };

  const loadTrustAccountBalance = (account_id, case_id, accountType) => {
    if (accountType === 'operating') {
      getOperatingAccountBalance(account_id, case_id)
        .then((response) => {
          setOperatingBalance(response?.data?.available_balance ? parseFloat(response?.data?.available_balance) : 0);
        })
        .catch((err) => {});
    } else {
      getTrustAccountBalance(account_id, case_id)
        .then((response) => {
          setTrustBalance(response?.data?.available_balance ? parseFloat(response?.data?.available_balance) : 0);
          setOpeningBalance(response?.data?.opening_balance ? parseFloat(response?.data?.opening_balance) : 0);
          setReconciledBalance(response?.data?.unmapped_qb_balance ? parseFloat(response?.data?.unmapped_qb_balance) : 0);
          setTotalTrustBalance(response?.data?.total_trust_balance ? parseFloat(response?.data?.total_trust_balance) : 0);
          setDesignatedAsTempTrustFunds(
            response?.data?.designated_as_temp_trust_funds ? parseFloat(response?.data?.designated_as_temp_trust_funds) : 0
          );
          setTrustFundAvailableToBillAgainst(
            response?.data?.trust_fund_available_to_bill_against ? parseFloat(response?.data?.trust_fund_available_to_bill_against) : 0
          );
          setAvailableBalance(response?.data?.available_balance ? parseFloat(response?.data?.available_balance) : 0);
        })
        .catch((err) => {});
    }
  };

  return {
    trustBalance,
    pageSize,
    trustLogs,
    hasNext,
    hasPrevious,
    fetchNext,
    fetchprev,
    onPageChange,
    loadTrustLogs,
    loadTrustAccountBalance,
    operatingBalance,
    openingBalance,
    reconciledBalance,
    totalTrustBalance,
    designatedAsTempTrustFunds,
    trustFundAvailableToBillAgainst,
    availableBalance,
  };
}
